import {initEventForm} from "./event-from";


const modal = document.getElementById('modal');
const formEl = modal.querySelector('form');

/**
 * Close modal
 */
export const closeEventModal = () => {
    closeModal();
}

/**
 * Open guest modal
 */
export const openGuestModal = () => {
    _openModal('guest', 'sponsor');
}

/**
 * Open sponsor modal
 */
export const openSponsorModal = () => {
    _openModal('sponsor', 'guest');
}

/**
 *
 * @param curr
 * @param prev
 */
const _openModal = (curr, prev) => {
    modal.classList.remove(prev);
    modal.classList.add(curr);
    modal.classList.add('m-show');

    // initModalForms(curr);
    initEventForm(formEl, curr);
};

const closeModal = () => {
    modal.classList.remove('m-show');
}

/**
 * Close modal when click to a modal backdrop
 */
document.addEventListener('mousedown', (e) => {
    if (e.target === modal) closeModal()
}, {passive: true});

